<template>
    <v-overlay light :value="isOpen" :z-index="600">
        <v-toolbar dense dark v-click-outside="close">
            <v-toolbar-title>{{fileName}}</v-toolbar-title>
            <v-btn right icon absolute @click.stop="close()" >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <iframe v-if="!loading"
                :src="src"
                frameborder="0"
                style="overflow:hidden;"
                height="92%"
                width="100%"
                :z-index="5"/>
        <div v-else class="text-center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </div>
    </v-overlay>
</template>

<script lang="ts">
    import {Component, Vue, Prop, Emit, Watch} from "vue-property-decorator";

    @Component
    export default class PdfOverlay extends Vue {
        @Prop({type: Boolean, required: true}) loading: boolean;
        @Prop({required: true}) src: string;
        @Prop({required: true}) value: boolean;
        @Prop({required: true}) fileName: string;
        @Emit() input() { return this.isOpen; }

        isOpen: boolean = false;

        @Watch("value", {immediate: true})
        valueChanged() {
            this.isOpen = this.value;
        }
        close() {
            this.isOpen = false;
            this.input();
        }
    }
</script>